import { FC, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../hooks/redux-hooks";
import { setSEOSettings } from "../../../store/slices/main";
import artist_cap from "../../../assets/artist_cap.png";

type IProps = {
  icon: string;
  artistName: string;
  artistDescription: string;
  link?: string;
};

const ArtistCard: FC<IProps> = ({
  icon,
  artistName,
  artistDescription,
  link,
}) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [disableClick, setDisableClick] = useState<boolean>(false);
  const [clickTime, setClickTime] = useState<number | null>(null);

  const navigateAndSetSEOSettings = (
    link: string,
    appTitle: string,
    appDescription: string,
    appImg: string
  ) => {
    if (!disableClick) {
      navigate(`${link}`);
      dispatch(
        setSEOSettings({
          appTitle,
          appDescription,
          appImg,
        })
      );
    }
  };

  const handleMouseDown = () => {
    setClickTime(Date.now());
    setDisableClick(true);
    setTimeout(() => {
      setDisableClick(false);
    }, 10);
  };

  const handleClick = () => {
    const now = Date.now();
    if (clickTime && now - clickTime < 250) {
      navigateAndSetSEOSettings(
        `/artists/${link}`,
        artistName,
        artistDescription,
        icon || artist_cap
      );
    }
  };

  return (
    <div className="max-w-32 flex flex-col justify-center items-start pt-8 touch-pan-y">
      <div className="flex flex-col justify-center items-center select-none">
        <div
          onMouseDown={handleMouseDown}
          onClick={handleClick}
          onTouchStart={handleMouseDown}
          onTouchEnd={handleClick}
          className="max-w-[7.2rem] min-w-[7.2rem] h-[7.2rem] flex justify-start items-center overflow-hidden rounded-full shadow-lg mb-3 select-none cursor-pointer"
        >
          <img
            className="w-full h-full object-cover pointer-events-none select-none "
            src={icon !== "null" ? icon : artist_cap}
            alt={artistName}
            draggable={true}
          />
        </div>

        <h5
          onClick={() =>
            navigateAndSetSEOSettings(
              `/artists/${link}`,
              artistName,
              artistDescription,
              icon || artist_cap
            )
          }
          className="max-w-[7.6rem] mb-1 text-base font-semibold text-center text-black cursor-pointer md:hover:underline md:whitespace-nowrap overflow-hidden text-ellipsis"
        >
          {artistName}
        </h5>
      </div>
    </div>
  );
};

export default ArtistCard;
